import React from "react"
import SignUpEmployeeHasSamlPage from "../components/signup-employee-has-saml"

export default function SignUpEmployeeHasSaml() {
  return <SignUpEmployeeHasSamlPage />
}
